@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.modal-body {
  line-height: 1.5;
  height: 700px;
  overflow-y: hidden;
}

.start-step-wizard {
  padding: 0 !important;
  overflow-x: hidden;
}

.step-content {
  width: 100%;
}

.header {
  font-size: 20px;
  color: @wallet--header--text-color;
  padding-top: 6px;
  padding-bottom: 12px;
  line-height: 25px;
}

.pickup-header {
  margin-bottom: @space-16;
}
.wallet-registration-modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 480px;
  }
}
